var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.854 4.354a.5.5 0 0 0-.708-.708l-8 8a.5.5 0 0 0 0 .708l8 8a.5.5 0 0 0 .708-.708L12.207 12zm-8 0a.5.5 0 0 0-.708-.708l-8 8a.5.5 0 0 0 0 .708l8 8a.5.5 0 0 0 .708-.708L4.207 12z",
    clipRule: "evenodd"
  })));
});
const SvgDoubleChevronLeft = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronLeft);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS44NTM2IDQuMzUzNTVDMjAuMDQ4OCA0LjE1ODI5IDIwLjA0ODggMy44NDE3MSAxOS44NTM2IDMuNjQ2NDVDMTkuNjU4MyAzLjQ1MTE4IDE5LjM0MTcgMy40NTExOCAxOS4xNDY0IDMuNjQ2NDVMMTEuMTQ2NCAxMS42NDY0QzEwLjk1MTIgMTEuODQxNyAxMC45NTEyIDEyLjE1ODMgMTEuMTQ2NCAxMi4zNTM2TDE5LjE0NjQgMjAuMzUzNkMxOS4zNDE3IDIwLjU0ODggMTkuNjU4MyAyMC41NDg4IDE5Ljg1MzYgMjAuMzUzNkMyMC4wNDg4IDIwLjE1ODMgMjAuMDQ4OCAxOS44NDE3IDE5Ljg1MzYgMTkuNjQ2NEwxMi4yMDcxIDEyTDE5Ljg1MzYgNC4zNTM1NVpNMTEuODUzNiA0LjM1MzU1QzEyLjA0ODggNC4xNTgyOSAxMi4wNDg4IDMuODQxNzEgMTEuODUzNiAzLjY0NjQ1QzExLjY1ODMgMy40NTExOCAxMS4zNDE3IDMuNDUxMTggMTEuMTQ2NCAzLjY0NjQ1TDMuMTQ2NDUgMTEuNjQ2NEMyLjk1MTE4IDExLjg0MTcgMi45NTExOCAxMi4xNTgzIDMuMTQ2NDUgMTIuMzUzNkwxMS4xNDY0IDIwLjM1MzZDMTEuMzQxNyAyMC41NDg4IDExLjY1ODMgMjAuNTQ4OCAxMS44NTM2IDIwLjM1MzZDMTIuMDQ4OCAyMC4xNTgzIDEyLjA0ODggMTkuODQxNyAxMS44NTM2IDE5LjY0NjRMNC4yMDcxMSAxMkwxMS44NTM2IDQuMzUzNTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";